import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] text-[#F4F4F0]">
      {/* CTA Section */}
      <div className="px-6 md:px-12 lg:px-24 py-24 md:py-32 border-b border-[#F4F4F0]/10">
        <div className="max-w-5xl">
          <p className="text-xs uppercase tracking-[0.2em] text-[#F4F4F0]/50 mb-6">
            Start a Project
          </p>
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-light mb-8">
            Let's create something
            <br />
            extraordinary together.
          </h2>
          <Link
            to="/contact"
            data-testid="footer-contact-link"
            className="inline-flex items-center gap-3 bg-[#F4F4F0] text-[#1A1A1A] px-8 py-4 uppercase tracking-widest text-xs hover:bg-[#3A4D39] hover:text-[#F4F4F0] transition-colors duration-300">

            Get in Touch
            <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>

      {/* Footer Content */}
      <div className="px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link
              to="/"
              className="inline-block"
              data-testid="footer-logo">

              <img 
                src="https://customer-assets.emergentagent.com/job_design-farmhouse/artifacts/5ma1d1zg_logo.PNG" 
                alt="IIDAS"
                className="h-[132px] w-auto"
              />
            </Link>
            <p className="mt-6 text-[#F4F4F0]/60 text-sm leading-relaxed max-w-xs">
              Creating timeless architecture that harmonizes with nature and elevates the human experience.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#F4F4F0]/50 mb-6">
              Navigation
            </h4>
            <ul className="space-y-3">
              {["About", "Services", "Projects", "Team", "Contact"].map((item) =>
              <li key={item}>
                  <Link
                  to={`/${item.toLowerCase()}`}
                  data-testid={`footer-link-${item.toLowerCase()}`}
                  className="text-sm text-[#F4F4F0]/70 hover:text-[#F4F4F0] transition-colors">

                    {item}
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Services */}
          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#F4F4F0]/50 mb-6">
              Services
            </h4>
            <ul className="space-y-3">
              {["Architectural Design", "Interior Design", "Urban Planning", "Project Management"].map((item) =>
              <li key={item}>
                  <span className="text-sm text-[#F4F4F0]/70">
                    {item}
                  </span>
                </li>
              )}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#F4F4F0]/50 mb-6">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#F4F4F0]/50 mt-1 flex-shrink-0" />
                <span className="text-sm text-[#F4F4F0]/70">Near park kechi, Block FD, Dakshini Pitampura, Pitampura, New Delhi, Delhi, 110034
                  <br />

                </span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-[#F4F4F0]/50 flex-shrink-0" />
                <a
                  href="mailto:hello@iidas.com"
                  data-testid="footer-email"
                  className="text-sm text-[#F4F4F0]/70 hover:text-[#F4F4F0] transition-colors">hello@iidas.in


                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-[#F4F4F0]/50 flex-shrink-0" />
                <a
                  href="tel:+919876543210"
                  data-testid="footer-phone"
                  className="text-sm text-[#F4F4F0]/70 hover:text-[#F4F4F0] transition-colors">+91 9625858007


                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#F4F4F0]/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#F4F4F0]/40">
            © {currentYear} IIDAS Architecture. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-[#F4F4F0]/40 hover:text-[#F4F4F0]/70 transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-xs text-[#F4F4F0]/40 hover:text-[#F4F4F0]/70 transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;